import type { SVGProps } from "react";
// generated from Search.svg — do not edit manually
// prettier-ignore
export default function Search(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 21 21 L 17.5 17.5 M 20 11.5 C 20 16.1944 16.194 20 11.5 20 C 6.806 20 3 16.1944 3 11.5 C 3 6.8056 6.806 3 11.5 3 C 16.194 3 20 6.8056 20 11.5 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
